import { Routes, Route, useLocation } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import RequireAuth from "./utils/RequireAuth";
import MainHeader from "./component/header/MainHeader";
import "react-toastify/dist/ReactToastify.css";
import DashBoard from "./pages/Dashboard/DashBoard";
import LoginPage from "./pages/Login-page/LoginPage";
import Footer from "./component/footer/Footer";

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    //eslint-disable-next-line
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<MainHeader />}>
            <Route index element={<DashBoard />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer />
      <Footer />
    </>
  );
}

export default App;
